module.exports = __webpack_public_path__ + "assets/img/mecha-btn-7eefc5f1.png";